<template>
    <div class="navbar" :class="{'scrolledHeader': !scrolled}">
        <PopupZlatnik></PopupZlatnik>
        <!-- top -->
        <div class="top-bar" :class="{'has-buttons': showBackButton || showSearchButton}">
            <a v-if="showBackButton" ref="backButton" class="back-button" @click="goBack()"></a>
            <a href="#" v-if="showSearchButton" ref="searchButton" class="search-button" @click.prevent="toggleSearchInput()"></a>

            <!-- TODO Remove the title here -->
            <router-link :to="{ name: 'home'}"><p class="title" data-title=""> Toni Milun Liga <i v-if="round.title">|</i> {{ round.title }}</p></router-link>
            <transition name="fade">
                <a :href="poweredBy.imageLink"  ref="logo" v-if="poweredBy && poweredBy.imageUrl">
                    <div class="poweredby" v-if="poweredBy">
                        <p>powered by</p>
                        <img :src="poweredBy.imageUrl" alt="Liga, powered by sponzor slika" v-if="poweredBy && poweredBy.imageUrl"/>
                    </div>
                </a>
            </transition>

            <div class="s-w" v-bind:class="{'show': showSearchInputState}">
                <input v-if="showSearchInputState" type="text" v-model="searchValue" class="search" placeholder="Korisničko ime" v-on:keyup.enter="searchUsers">
            </div>
        </div>
    </div>
</template>

<script>
import PopupZlatnik from './popups/PopupZlatnik'

export default {
    name: 'navbar',
    props: {
        showBackButton: {
            type: Boolean,
            default: false
        },
        showSearchButton: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PopupZlatnik
    },
    computed: {
        counters () {
            return this.$store.state.counters
        },
        round () {
            return this.$store.state.round
        },
        appState () {
            return this.$store.state.appState
        },
        poweredBy () {
            return this.$store.state.metadata.poweredBy
        },
        showSearchInputState () {
            if (this.$router.currentRoute.name === 'search') {
                return true
            }
            return this.showSearchInput
        },
        searchedValue () {
            try {
                return this.$route.params.value
            } catch (error) { }
            return false
        }
    },
    data: function () {
        return {
            backButton: null,
            searchButton: null,
            showSearchInput: false,
            searchValue: null,
            logo: null,
            scrollOffset: 10,
            scrolled: true
        }
    },
    mounted: function () {
        this.backButton = this.$refs.backButton
        this.searchButton = this.$refs.searchButton
        this.logo = this.$refs.logo
        document.addEventListener('scroll', this.headerOnScroll)
        if (this.searchedValue) {
            this.searchValue = this.searchedValue
        }
    },
    methods: {
        toggleSearchInput () {
            this.showSearchInput = !this.showSearchInput
        },
        goBack () {
            this.$router.go(-1)
        },
        async searchUsers () {
            try {
                if (this.$router.currentRoute.name === 'search') {
                    this.$emit('search', this.searchValue)
                } else {
                    this.$router.push(`/search/${this.searchValue}`)
                }
            } catch (error) {
            }
        },
        headerOnScroll () {
            if (window.pageYOffset > this.scrollOffset) {
                this.scrolled = false
                this.showSearchInput = false
            } else {
                this.scrolled = true
            }
        }
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.headerOnScroll)
    }
}
</script>

<style lang="scss" scoped>
@mixin cf {
    &:after {
        display: block;
        visibility: hidden;
        height: 0;
        clear: both;
        content: "";
    }
}

$font-axiforma: 'axiforma';

.navbar {
    position: fixed;
    z-index: 500;
    left: 0;
    top: 0;
    width: 100%;
    left: 0%;
    height: 100vh;
    pointer-events: none;
    &.scrolledHeader .top-bar {
        transform: translate3d( 0, -100%, 0);
    }
}

.top-bar {
    position: absolute;
    z-index: 10;
    padding: 24px 0 16px 0;
    top: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    pointer-events: auto;
    transition: transform .4s ease-in-out;

    .back-button {
        display: block;
        transition: background .3s ease;
        position: absolute;
        left: 30px;
        top: calc(50% - 12.5px);
        width: 25px;
        height: 25px;
        background: url(~@/assets/img/icons/arrow-back-black.png) 50% no-repeat;
        background-size: 24px;
    }
    .title {
        font-family: $font-axiforma;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 1px;
        text-align: center;
        margin-bottom: 10px;

        i {
            color: #3d85ce;
        }
    }
    &.has-buttons {
        .title {
            margin-left: 60px;
            margin-right: 60px;
        }
    }
    .search-button {
        display: block;
        position: absolute;
        right: 30px;
        top: calc(50% - 12.5px);
        width: 25px;
        height: 25px;

        &.active {
            background: url(~@/assets/img/icons/icon-search-3.png) 50% no-repeat;
            background-size: 23px;
        }
        &:before {
            transition: opacity .4s ease-in-out;
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(~@/assets/img/icons/icon-search-2.png) 50% no-repeat;
            background-size: 23px;
        }
        &:after {
            transition: opacity .4s ease-in-out;
            opacity: 0;
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(~@/assets/img/icons/icon-search-3.png) 50% no-repeat;
            background-size: 23px;
        }
    }
    .search-button:hover {
        &:after {
            opacity: 1;
        }
        &:before {
            opacity: 0;
        }
    }

    .s-w {
        padding: 12px 25px;
        background-position: 2px 50%;
        background-repeat: no-repeat;
        background-size: 16px;
        position: absolute;
        bottom: 5px;
        z-index: -1;
        width: 100%;
        background: #fff;
        padding-bottom: 10px;
        transition: all 0.3s ease-in-out;
        &.show {
            transform: translateY(100%);
        }
        &.show input.search {
            opacity: 1;
            transition-delay: 0.2s;
        }
    }
    input.search {
        padding-left: 30px;
        font-family: "axiforma";
        font-weight: 400;
        line-height: 22px;
        font-size: 14px;
        letter-spacing: .3px;
        width: 100%;
        border: none;
        appearance: none;
        background-color: transparent;
        outline: none;
        color: #ff007c;
        background-image: url(~@/assets/img/icons/icon-search.png);
        background-size: 16px;
        background-repeat: no-repeat;
        background-position: 0 50%;
        opacity: 0;
        transition: all 0.3s ease-in-out;
    }
    a.delete {
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);
        width: 30px;
        height: 30px;
        background: url(~@/assets/img/icons/icon-close-3.png) 50% no-repeat;
        background-size: 13px;
    }
}

.select-menu {
    display: block;

    a {
        display: block;
        font-family: $font-axiforma;
        padding: 12px 0;
        font-weight: 400;
        letter-spacing: .3px;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 5px;
    }
    strong {
        display: block;
        font-weight: 800;
        letter-spacing: -.2px;
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 5px;
        margin-top: 25px;
    }
}
.poweredby {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    p, image {
        display: block;
        position: relative;
    }
    p {
        float: left;
        margin: 0;
        color: #999;
        font-weight: 700;
        font-size: 12px;
        margin-right: 4px;
    }
    img {
        float: right;
        max-width: 90px;
    }
}

</style>
